import Vue from 'vue'
import master from '../masterModules/masterMutation.js'
// location-action
const URL = process.env.API_URL
const header = master.state.header

export default {
  inputUpdate(store, payload) {
    store.commit('inputUpdate', payload)
  },
  inputAddUpdate(store, payload) {
    store.commit('inputAddUpdate', payload)
  },
  clearTemplate(store) {
    store.commit('clearTemplate')
  },
  updateSelectedTemplateList(store, payload) {
    store.commit('updateSelectedTemplateList', payload)
  },
  clearSelectedTemplateList(store) {
    store.commit('clearSelectedTemplateList')
  },
  async addTemplate(store) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 300
    }
    const data = {
      header,
      data: {
        title: store.state.addTemplate['title'],
        message: store.state.addTemplate['message']
      }
    }
    await Vue.http.post(URL + '/v2/admin/template/regist', data, config)
  },
  async setTemplates(store, payload) {
    store.state.templates = []
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: {
        pageNo: payload.pageNo,
        count: 20
      }
    }
    var response = await Vue.http.post(
      URL + '/v2/admin/template/list',
      data,
      config
    )
    // 成功
    store.commit('setTemplates', response)
  },
  async updateTemplate(store) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 300
    }
    const data = {
      header,
      data: {
        id: store.state.updateTemplate['id'],
        title: store.state.updateTemplate['title'],
        message: store.state.updateTemplate['message']
      }
    }
    await Vue.http.post(URL + '/v2/admin/template/update', data, config)
  },
  async deleteTemplates(store, payload) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 300
    }
    const data = {
      header,
      data: {
        ids: payload
      }
    }
    await Vue.http.post(URL + '/v2/admin/template/delete', data, config)
  },
  async setDetailTemplate(store, payload) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: {
        id: payload.id
      }
    }
    var response = await Vue.http.post(
      URL + '/v2/admin/template/detail',
      data,
      config
    )
    // 成功
    store.commit('setDetail', response)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/templateModules/actions.js